import { Vue, Component } from 'vue-property-decorator';
import { Device } from '~/interfaces/device.interface';
import { LayoutModule } from '~/store/modules/layout';
import { newTrigramTypePipe } from '~/filters/newTrigramTypePipe';
import { humanReadableField } from '~/filters/humanReadableField';

@Component
export default class ModuleFiltering extends Vue {

    isModuleFiltered(moduleData: Device) {
        if (!moduleData?.shouldShowDevice) {
            return false;
        }

        if (!LayoutModule.treeFilter) {
            return true;
        }

        // case insensitive regex of the searched string
        const searchRegExp = new RegExp(LayoutModule.treeFilter, 'i');
        // keys in which we want to find the searched string
        // if the searched string is found in at least one of the searched keys values
        // (raw or piped values depending on the key we are trying to match), return true
        return (['name', 'id', 'type'] as Array<'name' | 'id' | 'type'>).some((key) => {
            const valueFoundInRawValue = moduleData[key] && (moduleData[key] as string).search(searchRegExp) > -1;
            const valueFoundInPipedValue =
                key === 'type'
                && moduleData[key]
                && (
                    (newTrigramTypePipe(moduleData[key]) as string).search(searchRegExp) > -1
                    || humanReadableField(moduleData[key]).search(searchRegExp) > -1
                );
            return valueFoundInRawValue || valueFoundInPipedValue;
        });
    }
}
